export default "__VITE_ASSET__CtsUtuM7__"